module.exports = __webpack_public_path__ + "img/Logos-EJ-pirelli-NB.5789c7bf.jpg";